import { defineMessages } from "react-intl";

const baseId = "t.components.modals.commentModal.";

export default defineMessages({
  title: {
    id: baseId + "title",
    defaultMessage: "Attention",
  },
  confirm: {
    id: baseId + "confirm",
    defaultMessage: "Confirm",
  },
  cancel: {
    id: baseId + "cancel",
    defaultMessage: "Cancel",
  },
});
